export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">APP下载</h2>
        </div>

        <div className="bg-gradient-to-br from-background-900 to-background-800 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-300 text-xs font-medium mb-4 whitespace-nowrap">
                随时随地，想吃就吃
              </span>
              <h3 className="text-2xl md:text-3xl font-heading text-white mb-3">
                下载吃瓜网51 APP
              </h3>
              <p className="text-sm md:text-base text-white/65 leading-relaxed mb-6 max-w-md">
                重大爆料事件实时推送，离线也能看黑料。更快的更新速度，更流畅的阅读体验，更安全的匿名投稿通道。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-3 px-6 py-3 rounded-xl bg-white/10 border border-white/15 cursor-pointer hover:bg-white/15 transition-colors">
                  <i className="ri-apple-fill text-white text-2xl"></i>
                  <div className="text-left">
                    <div className="text-xs text-white/55">Download on the</div>
                    <div className="text-sm font-semibold text-white whitespace-nowrap">App Store</div>
                  </div>
                </div>
                <div className="flex items-center gap-3 px-6 py-3 rounded-xl bg-white/10 border border-white/15 cursor-pointer hover:bg-white/15 transition-colors">
                  <i className="ri-google-play-fill text-white text-2xl"></i>
                  <div className="text-left">
                    <div className="text-xs text-white/55">GET IT ON</div>
                    <div className="text-sm font-semibold text-white whitespace-nowrap">Google Play</div>
                  </div>
                </div>
              </div>
              <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs text-white/45">
                <span className="flex items-center gap-1"><i className="ri-shield-check-line"></i> 隐私保护</span>
                <span className="flex items-center gap-1"><i className="ri-flashlight-line"></i> 极速加载</span>
                <span className="flex items-center gap-1"><i className="ri-notification-3-line"></i> 实时推送</span>
              </div>
            </div>
            <div className="flex-shrink-0 w-full lg:w-auto px-8 md:px-12 lg:px-0 lg:pr-12 pb-8 lg:pb-0 flex justify-center">
              <div className="relative w-48 md:w-56 aspect-[9/16] rounded-2xl overflow-hidden border-2 border-white/20">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20mobile%20app%20interface%20mockup%20in%20dark%20theme%20with%20warm%20red%20accents%2C%20news%20feed%20style%20layout%2C%20abstract%20content%20cards%2C%20clean%20minimalist%20UI%20design%2C%20no%20real%20text%20no%20people%2C%20editorial%20app%20aesthetic&width=560&height=1000&seq=app-51-017&orientation=portrait"
                  alt="吃瓜网51 APP界面预览"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}